module.exports = __webpack_public_path__ + "img/Polimeccanico-AB-034.237c4b26.jpg";